import { render, staticRenderFns } from "./TicketCreateNewTicket.vue?vue&type=template&id=dbfb0744&scoped=true&"
import script from "./TicketCreateNewTicket.vue?vue&type=script&lang=js&"
export * from "./TicketCreateNewTicket.vue?vue&type=script&lang=js&"
import style0 from "./TicketCreateNewTicket.vue?vue&type=style&index=0&id=dbfb0744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfb0744",
  null
  
)

export default component.exports